// @flow

import React, { useMemo, type StatelessFunctionalComponent } from "react";
import { Provider } from "react-redux";
import DocumentTitle from "react-document-title";
import configureStore from "./store";
import Notification from "../../components/Notification";
import CreateIppContainer from "../../containers/CreateIpp";

const CreateIpp: StatelessFunctionalComponent<{}> = () => {
  const store = useMemo(configureStore, []);
  return (
    <DocumentTitle title="Create IPP">
      <Provider store={store}>
        <CreateIppContainer />
        <Notification />
      </Provider>
    </DocumentTitle>
  );
};
export default CreateIpp;
